module.exports = __webpack_public_path__ + "img/qualia.82af00e7.png";